<div class="custom-stepper">

  <div class="step-indicator">
    <div *ngFor="let step of steps; let i = index" [class.active]="i === currentStep" (click)="onStepLabelClick(i)">
      <div class="step-number">{{ i + 1 }}</div>
      <div class="step-label">{{ step.label }}</div>
      <div class="step-line" *ngIf="i < steps.length - 1"></div>
    </div>
  </div>
  
  <div class="step-content" *ngIf="steps && steps.length > 0">
    <app-fb-simple-form #simpleForm
      [simpleFormButton]="btnClick ? simpleFormButton : steps[currentStep].simpleFormButton"
      [pageFormType]="steps[currentStep].pageFormType"
      [formTypeSelected]="steps[currentStep].formTypeSelected"
      [isFBModulePreview]="steps[currentStep].isFBModulePreview"
      [formBuilderInfo]="steps[currentStep].formBuilderInfo"
      [dataFormId]="btnClick ? dataFormId :steps[currentStep].formDataId"
      [fields]="steps[currentStep].fields"
      [stepNumber]="steps[currentStep].stepNumber"
      [isMultiStep]="true"
      [currentStep]="currentStep"
      [steps]="steps"
      (backToMasterList)="onBackToMasterList()"
    ></app-fb-simple-form>
    <div class="multiBtn">
      <button class="btn btn-primary" [disabled]="currentStep === 0" (click)="onPrevious()">Previous</button>
      <!-- <button class="btnNext btn btn-primary" *ngIf="showSaveNext && currentStep != steps.length - 1"  (click)="onSaveNext()">Save & Next</button> -->
      <button class="btnNext btn btn-primary" [disabled]="currentStep === steps.length - 1" (click)="onNext()">Next</button>
    </div>
  </div>
</div>
